<template>
  <div class="start-image">
    <div class="info-text">
      <p>提示：您可以在此处配置广告宣传纵图，配置后可跳转至链接或指定产品</p>
      <p>该图片尺寸为手机屏幕尺寸，由于手机品牌型号众多，为避免部分手机展示异常，您可根据常用品牌、机型配置多种尺寸的启动页图片；</p>
      <p>如不配置则不会显示。</p>
    </div>
    <div class="tools-box">
      <div class="input-box"></div>
      <Button type="primary" style="width: 80px" @click="$refs.bannerConfigRef.open({})" v-show="$units.pointAction('systemSet_10_5')">新增</Button>
    </div>

    <loading :isShow="$root.$children[0].isShowLoading" />
    <div class="table-box" v-loading="loading">
      <Table :columns="columns" :data="tableData">
        <!-- 图片 -->
        <template slot-scope="{ row }" slot="img">
          <uploadNew v-model="row.imgUrl" :disabled="true" class="img-box"></uploadNew>
        </template>
        <!-- 操作 -->
        <template slot-scope="{ row }" slot="action">
          <span class="table-btn" @click="$refs.bannerConfigRef.open(row)" v-show="$units.pointAction('systemSet_10_5')">编辑</span>
          <span class="table-btn" @click="submitDelete(row)" v-show="$units.pointAction('systemSet_10_6')">删除</span>
        </template>
      </Table>
    </div>

    <div class="pageBox">
      <Page :total="total" :current="pageNo" :page-size="pageSize" show-total @on-change="pageChange" style="text-align: center" />
    </div>

    <bannerConfigForm ref="bannerConfigRef" :getTabList="getTabList"></bannerConfigForm>
  </div>
</template>
<script>
import uploadNew from '@/components/commons/uploadNew';
import bannerConfigForm from './components/bannerConfigForm';
import filters from "@/api/filter";
export default {
  components: {
    bannerConfigForm,
    uploadNew
  },
  data: () => ({
    loading: false,
    total: 0,
    pageNo: 1,
    pageSize: 10,
    tableData: [],
    columns: []
  }),
  mounted() {
    this.columns = this.getTableColumns();
    // if (!this.$units.pointAction('systemSet_10_1') && !this.$units.pointAction('systemSet_10_2')) {
    //   this.columns.splice(this.columns.length - 1, 1);
    // }
    if (!this.$units.pointAction('systemSet_10_5') && !this.$units.pointAction('systemSet_10_6')) {
      this.columns.splice(this.columns.length - 1, 1);
    }
    this.getTabList();
  },
  methods: {
    getTableColumns() {
      const table = [
        {
          title: '序号',
          type: 'index',
          width: 80,
          align: 'center'
        },

        {
          title: '图片',
          slot: 'img',
          minWidth: 140,
          align: 'center'
        },

        {
          title: '应用平台',
          minWidth: 200,
          align: 'center',
          render(h, params) {
            const result = params.row.systemType;
            return <span>{result == '1' ? 'iOS' : 'Android'}</span>;
          }
        },
        {
          title: '尺寸',
          minWidth: 200,
          align: 'center',
          key: 'imgSize'
        },
        {
          title: '有效期',
          minWidth: 200,
          align: 'center',
          render(h, params) {
            let effectTimeStart = params.row.effectTimeStart;
            let effectTimeEnd = params.row.effectTimeEnd;
            if(effectTimeStart && effectTimeEnd) {
              return <span>{ filters.filterTime(effectTimeStart, 'YYYY-MM-DD') } 至 { filters.filterTime(effectTimeEnd, 'YYYY-MM-DD') }</span>
            }else{
              return <span>长期有效</span>
            }
          }
        },
        {
          title: '跳转类型',
          minWidth: 200,
          align: 'center',
          key: '',
          render(h, params) {
            let jumpType = params.row.jumpType;
            if(jumpType == 1) {
              return <span>链接</span>
            }else{
              return <span>产品</span>
            }
          }
        },
        {
          title: '跳转内容',
          minWidth: 200,
          align: 'center',
          render(h, params) {
            let jumpType = params.row.jumpType;
            let productName = params.row.productName;
            let url = params.row.url;
            if(jumpType == 1) {
              return <span>{ url }</span>
            }else{
              return <span>{ productName }</span>
            }
          }
        },
        {
          title: '操作',
          slot: 'action',
          width: 120,
          align: 'center'
        }
      ];
      return table;
    },

    // 获取列表数据
    getTabList() {
      this.$root.$children[0].isShowLoading = true;
      this.$http({
        type: 'POST',
        url: '/buz/personalizedconfig/advertisPageConfig/list',
        data: {
          pageNo: this.pageNo,
          pageSize: this.pageSize
        }
      }).then(res => {
        this.total = res.total;
        this.tableData =
          res.data &&
          res.data.map(item => {
            return {
              ...item,
              imgUrl: { path: item.imgUrl }
            };
          });
        this.$root.$children[0].isShowLoading = false;
      });
    },

    // 删除
    submitDelete(item) {
      this.$notice.inquiry('确认删除操作？').then(async () => {
        this.$http({
          url: `/buz/personalizedconfig/advertisPageConfig/del?id=${item.id}`,
          type: 'GET'
        }).then(res => {
          this.$Message.success('删除成功');
          this.getTabList();
        });
      });
    },

    // 分页
    pageChange(pageNo) {
      this.pageNo = pageNo;
      this.getTabList();
    }
  }
};
</script>
<style lang="scss" scoped>
@import './bannerConfig.scss';
</style>
